import { PapiSellerDiscount } from '@wix/da-papi-types';

import { formatDollars } from './formatting';

export function getDiscountedPrice(
  price?: number,
  discount?: PapiSellerDiscount
) {
  let discountedPrice = price;
  if (price !== undefined && discount?.amount?.usd) {
    discountedPrice = price - discount?.amount?.usd;
  }

  return {
    price,
    discountedPrice,
    discountedAmount: discount?.amount?.usd,
  };
}

export function normalizeDiscountPrice(
  dollarAmount: number,
  discount?: PapiSellerDiscount,
  options?: { optionalDecimalDigits: boolean }
): {
  dollarAmount?: number;
  formattedDollarAmount?: string;
  dollarAmountAfterDiscount?: number;
  formattedDollarAmountAfterDiscount?: string;
  discountDollarAmount?: number;
  formattedDiscountDollarAmount?: string;
} {
  const formatOptions = options?.optionalDecimalDigits
    ? {
        useGrouping: true,
      }
    : undefined;

  const { price, discountedPrice, discountedAmount } = getDiscountedPrice(
    dollarAmount,
    discount
  );
  const formattedDollarAmount = formatDollars(price, formatOptions);
  const formattedDollarAmountAfterDiscount = formatDollars(
    discountedPrice,
    formatOptions
  );
  const formattedDiscountDollarAmount = formatDollars(
    discountedAmount,
    formatOptions
  );

  return {
    dollarAmount: price,
    formattedDollarAmount,
    dollarAmountAfterDiscount: discountedPrice,
    formattedDollarAmountAfterDiscount,
    discountDollarAmount: discountedAmount,
    formattedDiscountDollarAmount,
  };
}
